import React from 'react';
import AdminPage from './components/AdminPage';

const AdminPageContainer: React.FC = (): React.ReactElement => {
  return <AdminPage />;
};

export default AdminPageContainer; 